module.exports = __webpack_public_path__ + "static/media/xiao3.beae71ea.webp";